
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-enquiry",
      function () {
        return require("private-next-pages/product-enquiry.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-enquiry"])
      });
    }
  